import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=fa981de4&scoped=true&"
import script from "./temperature.vue?vue&type=script&lang=js&"
export * from "./temperature.vue?vue&type=script&lang=js&"
import style0 from "./temperature.vue?vue&type=style&index=0&id=fa981de4&prod&lang=css&"
import style1 from "./temperature.vue?vue&type=style&index=1&id=fa981de4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa981de4",
  null
  
)

export default component.exports